import { useUser } from '../../contexts/UserContext';
import { canManageSelectedCompany } from '../AppShell/companyAdminAccess';

export interface CompanyAdminScope {
  canManage: boolean;
  companyId: string | null;
  companyName: string;
  instanceId: string | null;
  membershipRole: string | null;
}

export function useCompanyAdminScope(): CompanyAdminScope {
  const { user, selectedCompany, availableCompanies } = useUser();
  const match = availableCompanies.find((row) => row.company.id === selectedCompany?.id);
  const membershipRole = match?.instance.role ?? null;
  return {
    canManage: canManageSelectedCompany(user, membershipRole),
    companyId: selectedCompany?.id ?? null,
    companyName: selectedCompany?.name ?? '',
    instanceId: selectedCompany?.instance_id ?? match?.instance.id ?? null,
    membershipRole,
  };
}
